<div class="typeahead-input">
  <markant-input
    id="typeahead-input"
    type="text"
    [formControl]="searchTerm"
    [placeholder]="placeholder"
    outlined="true"
    [label]="label"
    (focusin)="onFocus()"
    (focusout)="onFocus()"
  >
    <markant-icon slot="markant-icon-leading" icon="m_search"></markant-icon>
  </markant-input>
  <markant-icon [ngClass]="{customFocus: isInFocus}" class="fixedClickableIcon" icon="close--dense" (click)="clearInput()"></markant-icon>
</div>
